<template>
  <div class="input-group" :class="{'input-group-invalid': isInvalid, 'input-group-disabled': isDisabled}">

    <FieldLabel :is-required="isRequired" :label-link-text="labelLinkText" :label-link-url="labelLinkUrl"><slot>{{ label }}</slot></FieldLabel>
    <span class="btn-box">
        <button
            type="button"
            v-for="option in optionsList"
            :key="option[0]"
            class="btn"
            :class="inputValue === option[1] ? 't-on' : 't-off'"
            @click="() => setValue(option[1])"
            :disabled="isDisabled"
        >{{ option[0] }}</button>
      </span>

  </div>
</template>

<script>
import {defaultProps} from "./defaultProps";

export default {
  name: "i-options",
  props: {
    ...defaultProps,
    options: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    inputValue: null,
    isInvalid: false,
    hasTouched: false,
  }),
  methods: {
    inputHandle() {
      this.hasTouched = true;
      this.$emit('input', this.inputValue);
    },
    validate() {
      this.isInvalid = (this.isRequired && this.inputValue === null);
    },
    clean() {
      this.inputValue = null;
      this.isInvalid = false;
      this.hasTouched = false;
    },
    setValue(value) {
      this.inputValue = value;
      this.validate();
      this.inputHandle();
    },
    isValid() {
      this.validate();
      return !this.isInvalid;
    },
  },
  computed: {
    optionsList() {
      return Object.entries(this.options);
    }
  },
  watch: {
    value(v) {
      this.setValue(v);
    },
  },
  mounted() {
    this.inputValue = this.value;
  },
}
</script>

<style scoped lang="scss">
@import "../../styles/color";

.btn-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 15px;

  .btn {
    flex-grow: 1;
  }
}

.input-group-invalid {
  color: $red2;
}

.btn {
  &.t-on {
    --cor1: #4BC49061;
    --cor2: #4BC4908A;
    --cor3: #151212;
  }

  &.t-off {
    --cor1: transparent;
    --cor2: #D7D7D8;
    --cor3: #4F4F4FB8;
  }

  background: var(--cor1);
  border: 1.5px solid var(--cor2);
  color: var(--cor3);
}
</style>
